import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import {
  ChangeDigitalSignatureProcessClientRequest,
  ChangeDigitalSignatureProcessClientResponse,
} from '../../../@types/ChangeDigitalSignatureProcess'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import { api } from '../../../Services/API'
import { useDigitalSignatureSettingsStore } from '../../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { useChangeDigitalSignatureProcessStore } from '../../../Stores/useChangeDigitalSignatureProcessStore'
import { useSendDigitalSignatureStore } from '../../../Stores/useSendDigitalSignatureStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: ChangeDigitalSignatureProcessClientRequest) => {
  const { data } = await api.post<ChangeDigitalSignatureProcessClientResponse>(
    API_ROUTES.changeDigitalSignatureProcess,
    payload,
  )

  return data
}

export const useChangeDigitalSignatureProcess = () => {
  const { setChangeDigitalSignatureProcess } =
    useChangeDigitalSignatureProcessStore()
  const { setSendDigitalSignature } = useSendDigitalSignatureStore()
  const { setIsChangedDigitalSignature } = useDigitalSignatureSettingsStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: ChangeDigitalSignatureProcessClientRequest) =>
      request(payload),
    onSuccess: (data) => {
      setChangeDigitalSignatureProcess(data)
      setSendDigitalSignature(data)
      setIsChangedDigitalSignature(false)
    },
    onError: (error: AxiosError<ErrorHandling[]>) => {
      handleErrorRequest({ error })
    },
  })
}
